import { FaReact, FaAppStoreIos, FaGooglePlay, FaJira, FaAws } from 'react-icons/fa';
import { RiJavascriptFill } from 'react-icons/ri';
import { BiLogoTypescript, BiLogoFlutter } from 'react-icons/bi';
import {
    SiTailwindcss,
    SiFastify,
    SiNextdotjs,
    SiGoogle,
    SiReactrouter,
    SiRedux,
    SiReactquery,
    SiCssmodules,
    SiStyledcomponents,
    SiMui,
    SiExpress,
    SiGraphql,
    SiMongodb,
    SiPostman,
    SiJenkins,
    SiCursor,
    SiGithubcopilot,
} from 'react-icons/si';
import { DiHtml5, DiCss3 } from 'react-icons/di';
import { IoLogoNodejs, IoLogoGithub, IoLogoFirebase, IoLogoPython } from 'react-icons/io5';

const ICON_SIZE = 60;

const frontendSkills = [
    {
        _id: '5',
        icon: <FaReact size={ICON_SIZE} color='var(--icons-color)' />,
        name: 'React',
    },
    {
        _id: '28',
        icon: <SiNextdotjs size={ICON_SIZE} color='var(--icons-color)' />,
        name: 'Next.js',
    },
    {
        _id: '3',
        icon: <RiJavascriptFill size={ICON_SIZE} color='var(--icons-color)' />,
        name: 'JavaScript',
    },
    {
        _id: '4',
        icon: <BiLogoTypescript size={ICON_SIZE} color='var(--icons-color)' />,
        name: 'TypeScript',
    },
    {
        _id: '6',
        icon: <SiReactrouter size={ICON_SIZE} color='var(--icons-color)' />,
        name: 'React Router',
    },
    {
        _id: '7',
        icon: <SiRedux size={ICON_SIZE} color='var(--icons-color)' />,
        name: 'Redux',
    },
    {
        _id: '8',
        icon: <SiReactquery size={ICON_SIZE} color='var(--icons-color)' />,
        name: 'React Query',
    },
    {
        _id: '9',
        icon: <SiCssmodules size={ICON_SIZE} color='var(--icons-color)' />,
        name: 'CSS Modules',
    },
    {
        _id: '10',
        icon: <SiStyledcomponents size={ICON_SIZE} color='var(--icons-color)' />,
        name: 'Styled Components',
    },
    {
        _id: '11',
        icon: <SiTailwindcss size={ICON_SIZE} color='var(--icons-color)' />,
        name: 'Tailwind CSS',
    },
    {
        _id: '12',
        icon: <SiMui size={ICON_SIZE} color='var(--icons-color)' />,
        name: 'Material UI',
    },
    {
        _id: '1',
        icon: <DiHtml5 size={ICON_SIZE} color='var(--icons-color)' />,
        name: 'HTML5',
    },
    {
        _id: '2',
        icon: <DiCss3 size={ICON_SIZE} color='var(--icons-color)' />,
        name: 'CSS3',
    },
];

const mobileSkills = [
    {
        _id: '5',
        icon: <FaReact size={ICON_SIZE} color='var(--icons-color)' />,
        name: 'React Native',
    },
    {
        _id: '17',
        icon: <BiLogoFlutter size={ICON_SIZE} color='var(--icons-color)' />,
        name: 'Flutter',
    },
    {
        _id: '20',
        icon: <FaAppStoreIos size={ICON_SIZE} color='var(--icons-color)' />,
        name: 'App Store Connect',
    },
    {
        _id: '21',
        icon: <FaGooglePlay size={ICON_SIZE} color='var(--icons-color)' />,
        name: 'Google Play Console',
    },
];

const backendSkills = [
    {
        _id: '13',
        icon: <IoLogoNodejs size={ICON_SIZE} color='var(--icons-color)' />,
        name: 'Node.js',
    },
    {
        _id: '14',
        icon: <SiExpress size={ICON_SIZE} color='var(--icons-color)' />,
        name: 'Express',
    },
    { _id: '24', icon: <SiFastify size={ICON_SIZE} color='var(--icons-color)' />, name: 'Fastify' },
    {
        _id: '15',
        icon: <SiGraphql size={ICON_SIZE} color='var(--icons-color)' />,
        name: 'GraphQL',
    },
    {
        _id: '16',
        icon: <SiMongodb size={ICON_SIZE} color='var(--icons-color)' />,
        name: 'MongoDB',
    },
];

const devToolsSkills = [
    {
        _id: '19',
        icon: <IoLogoGithub size={ICON_SIZE} color='var(--icons-color)' />,
        name: 'Git & GitHub',
    },
    {
        _id: '18',
        icon: <IoLogoFirebase size={ICON_SIZE} color='var(--icons-color)' />,
        name: 'Firebase',
    },
    {
        _id: '22',
        icon: <SiPostman size={ICON_SIZE} color='var(--icons-color)' />,
        name: 'Postman',
    },
    {
        _id: '23',
        icon: <FaJira size={ICON_SIZE} color='var(--icons-color)' />,
        name: 'Jira',
    },
];

const aiToolsSkills = [
    {
        _id: '29',
        icon: <SiCursor size={ICON_SIZE} color='var(--icons-color)' />,
        name: 'Cursor',
    },
    {
        _id: '30',
        icon: <SiGoogle size={ICON_SIZE} color='var(--icons-color)' />,
        name: 'Antigravity',
    },
    {
        _id: '31',
        icon: <SiGithubcopilot size={ICON_SIZE} color='var(--icons-color)' />,
        name: 'GitHub Copilot',
    },
];

const familiarWithSkills = [
    {
        _id: '25',
        icon: <IoLogoPython size={ICON_SIZE} color='var(--icons-color)' />,
        name: 'Python',
    },
    {
        _id: '26',
        icon: <FaAws size={ICON_SIZE} color='var(--icons-color)' />,
        name: 'AWS',
    },
    {
        _id: '27',
        icon: <SiJenkins size={ICON_SIZE} color='var(--icons-color)' />,
        name: 'Jenkins',
    },
];

export { frontendSkills, mobileSkills, backendSkills, devToolsSkills, aiToolsSkills, familiarWithSkills };
